import { clearObject } from 'helpers/objects';
import { queryStringWithSort } from 'helpers/request';
import { isResponseError, TResponse } from 'models/apiClient';
import { ApiEndpoints } from 'models/apiEndpoints';
import {
  ILicenceFirearmsResponse,
  ILicenceReadLimitsResponse,
  ILicencesFirearmsSearchForm,
  ILicencesFirearmsSearchResponse,
  IWeaponLicenceFirearmToLink,
} from 'models/licencesFirearms';
import { ISortOptions } from 'models/table';
import { apiClient } from 'utils/apiClient';

const getLicencesFirearmsSearchToLink = async (
  page: number,
  size: number,
  sort: ISortOptions | null | undefined,
  query: Partial<ILicencesFirearmsSearchForm>,
) => {
  const qString = queryStringWithSort(
    {
      page: page - 1,
      size,
    },
    sort,
  );

  const deletedUniqueIds = query.deletedUniqueIds || [];

  const queryWithoutDeletedUniqueIds = { ...query };
  delete queryWithoutDeletedUniqueIds.deletedUniqueIds;

  const clearedOtherFields = clearObject(queryWithoutDeletedUniqueIds);

  const finalQuery = {
    ...clearedOtherFields,
    deletedUniqueIds: deletedUniqueIds,
  };

  const { data } = await apiClient.post<TResponse<ILicencesFirearmsSearchResponse>>(
    `${ApiEndpoints.GET_WEAPON_LICENSES_FIREARMS_SEARCH()}?${qString}`,
    finalQuery,
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const weaponLicenceFirearmsToLink = async (body: IWeaponLicenceFirearmToLink) => {
  const data = await apiClient.post<TResponse<IWeaponLicenceFirearmToLink>>(
    ApiEndpoints.WEAPON_LICENSES_FIREARMS_TO_LINK(),
    body,
  );
  return data;
};

const getLicenceWeapon = async (
  weaponLicenceUniqueId: string,
): Promise<ILicenceFirearmsResponse[] | null> => {
  const { data } = await apiClient.get<TResponse<ILicenceFirearmsResponse[]>>(
    ApiEndpoints.GET_LICENCE_WEAPON_FIREARMS(weaponLicenceUniqueId),
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getReadLimitsData = async (id: string): Promise<ILicenceReadLimitsResponse | null> => {
  const { data } = await apiClient.get<TResponse<ILicenceReadLimitsResponse>>(
    ApiEndpoints.GET_LICENCE_READ_LIMIT_FIREARMS(id),
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

export {
  getLicencesFirearmsSearchToLink,
  weaponLicenceFirearmsToLink,
  getLicenceWeapon,
  getReadLimitsData,
};
